<!-- <div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{parentData.title}} [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <mat-form-field appearance="outline" class="me-2" *ngIf="toShowTemplate">
        <mat-label>{{ 'services.label' | translate }}</mat-label>
        <input
        [formControl]="searchString"
         
          matInput
          placeholder="Enter keyword"
          (keyup)="searchServiceData()"
        />
        <button
        
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon >close</mat-icon>
      </button>
      </mat-form-field>

      <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>
</sm-misc-title-bar>
  <mat-dialog-content *ngIf="!toShowTemplate">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Service name</mat-label>
        <input
 
          [(ngModel)]="serviceListData.serviceName"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [(ngModel)]="serviceListData.description"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>SAC code</mat-label>
        <input
          
          [(ngModel)]="serviceListData.sac_code"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div style="margin-bottom: 15px;">

            
        
<!--         
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop"></mat-checkbox>
            <mat-label>Shop service</mat-label>
            
         
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome"></mat-checkbox>
            <mat-label>Home service</mat-label>
                        
            <mat-checkbox value="virtual" (change)="change($event)" ></mat-checkbox>
            <mat-label>Virtual service</mat-label> -->

               
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop" *ngIf="shop_status != '2'"></mat-checkbox>
            <mat-label *ngIf="shop_status != '2'">Shop service</mat-label>
            
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome" *ngIf="home_status != '2'"></mat-checkbox>
            <mat-label *ngIf="home_status != '2'">Home service</mat-label>
            
            <mat-checkbox value="virtual" (change)="change($event)" [checked]="isVirtual" *ngIf="virtual_status != '2'"></mat-checkbox>
            <mat-label *ngIf="virtual_status != '2'">Virtual service</mat-label>
            
        
    </div>
    
    <div *ngIf="isShopSpecific == true">
        <mat-form-field appearance="outline">
          <mat-label>Shop rate</mat-label>
          <input smDecimalOnly type="number"
          [(ngModel)]="serviceListData.shop_rate"
          matInput
        
        />
         
        </mat-form-field>
    </div>
    <div *ngIf="isHomeSpecific == true">
      <mat-form-field appearance="outline">
        <mat-label>Home rate</mat-label>
        <input smDecimalOnly type="number"
        [(ngModel)]="serviceListData.home_rate"
        matInput
      
      />
        
      </mat-form-field>
  </div>
  <div *ngIf="isVirtualSpecific == true">
    <mat-form-field appearance="outline">
      <mat-label>Virtual rate</mat-label>
      <input 
      [(ngModel)]="serviceListData.virtualRate"
      smDecimalOnly type="number"
      matInput
    
    />
      
    </mat-form-field>
</div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Approx time(in minutes)</mat-label>
        <input smNumericOnly
          [(ngModel)]="serviceListData.approxTime"
          matInput

        />
       
      </mat-form-field>
    </div>
     <div style="margin-bottom: 10px;">
        <mat-label>Set as membership package</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChangeForOnline($event)" [checked]="isOnlineAvailable"></mat-slide-toggle>
      <br><br>
        <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div style="margin-bottom: 10px;">
        <mat-label>Enable Discount</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChange($event)" [checked]="isDiscountApplicable"></mat-slide-toggle>
        <br><br>
<!-- 
        <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div *ngIf="serviceListData.discountStatus == '1'" style="margin-bottom: 10px;">
        <mat-label>Discount type</mat-label>
        <br><br>

        <input type="radio" id="percent" name="discountType" [checked]="isPercent == true" value="percent" (click)="discType($event)">
        <label for="percent" class="radlabel">Percent</label>
        <input type="radio" id="amount" name="discountType" [checked]="isAmount == true" value="amount" (click)="discType($event)">
        <label for="amount" class="radlabel">Amount</label>

    </div>
    <div *ngIf="serviceListData.discountStatus == '1'">
        <mat-form-field appearance="outline">
          <mat-label>Discount Amount</mat-label>
          <input smDecimalOnly type="number"
            [(ngModel)]="serviceListData.discountAmount"
            matInput
  
          />
         
        </mat-form-field>
      </div>
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="margin-bottom: 10px;">
      <mat-label>Enable tax</mat-label>
      <mat-slide-toggle style="    margin-left: 20px;
      position: relative;
      top: 2px;
  " class="share" (change)="onToggleChangeForTax($event)" [checked]="isTaxApplicable"></mat-slide-toggle>
    <br><br>
      <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
      <label for="yes" class="radlabel">Yes</label>
      <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
      <label for="no" class="radlabel">No</label> -->

  </div>
    <!-- [(value)]="selectedView" [(ngModel)]="selectedView" (ngModelChange)="changeView()" -->
    <div *ngIf="isTaxApplicable && taxSlabData.length > 0">
      <mat-form-field appearance="outline">
         <mat-select [(value)]="selectedSlab" [(ngModel)]="selectedSlab" class="w-100">
                     <mat-option value="default" >
                       Select a tax
                     </mat-option>
                     <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                       {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                     </mat-option>
                    
                   </mat-select>
      </mat-form-field>
     </div>
     <div *ngIf="isTaxApplicable && taxSlabData.length == 0">
      <p>Tax not configured yet. <a href="javascript:void(0)" (click)="configureTax()">Click to configure</a></p>
     </div>
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="toShowTemplate">
    <div class="row" *ngIf="serviceList.length>0">
        <div class="col-sm-4 service_temple_card" *ngFor="let item of serviceList">
            <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.imgUrl && item.imgUrl != 'null'">
                                    <img [src]="item.imgUrl">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.imgUrl || item.imgUrl == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                              
                                <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon
            >
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.serviceName}}</h3>
                                <!-- <p>{{
                                  item.description.length > 40
                                    ? item.description.substring(0, 40) + "..."
                                    : item.description
                                }}
                                </p> -->
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <p
                                class="two-line-ellipsis"
                                matTooltip="{{ item.description }}"
                                matTooltipPosition="above"
                                matTooltipShowDelay="300"
                              >
                                {{ item.description }}
                              </p>

                                <p style="margin-top: 10px;">Approx Time: {{item.approxTime}} minutes
                                </p>
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div *ngIf="datalength > serviceList.length" style="text-align: center;">
          <button
          style="
          width: 25%;
          border-radius: 50px;
      "
      mat-flat-button
      color="accent"
      (click)="seeMore()"
    >
      See more
    </button>
   
        </div>
        

    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowTemplate">
    <button mat-button (click)="back()">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !serviceListData.serviceName ||
        !serviceListData.description ||
        !serviceListData.approxTime ||
        priceCheker() ||
        discountChecker()
      "
      (click)="onPost()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>


  <mat-dialog-actions align="end" *ngIf="toShowTemplate">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedserviceList.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Next
    </button>
  </mat-dialog-actions>
  